export namespace breakpoints {
  export const small = 576;
  export const medium = 768;
  export const large = 992;
  export const extraLarge = 1200;
}
